import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import TextEditor from "../../../text-editor/TextEditor";
import { SortableList } from "../../../SortableList";
import { Button, Flex, InputNumber, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useAddLesson } from "../../../../stores/stores";
import {
  initialNumericalQuestionValue,
  ModeQuestion,
} from "../../../../constants";
import {
  QuestionAnswerInfo,
  QuestionData,
  QuestionItemDetail,
} from "../../../../types/course-construction";
import { findMaxIndexOfArray, mapAnsBEtoFE } from "../../../../utils/arrays";
import {
  renderQuestionNameByType,
  renderQuestionDescriptionByType,
} from "../../../../utils/functionUltils";
import QuestionNumericalItem from "./QuestionNumericalItem";
import "./style.scss";
import { useDirty } from "../../../../contexts/DirtyProvider";

function Numerical({
  data = {} as QuestionData,
  defaultName,
}: QuestionItemDetail) {
  const { t } = useTranslation();
  const question = useAddLesson((state: any) => state.question);
  const [questionName, setQuestionName] = useState<string>("");
  const [answers, setAnswers] = useState(initialNumericalQuestionValue);
  const modeQuestion = useAddLesson((state) => state.modeQuestion);

  const { setDirty } = useDirty();

  const [tolerance, setTolerance] = useState<number>(0);

  const setCurrentQuestionInfo = useAddLesson(
    (state) => state.setCurrentQuestionInfo
  );

  const handleChangeText = (current: { id: number; value: number }) => {
    const distAnswer = [...answers];
    const indexOfChangeItem = distAnswer.findIndex(
      (item: QuestionAnswerInfo) => item.id === current.id
    );
    if (indexOfChangeItem !== -1) {
      distAnswer[indexOfChangeItem] = {
        ...distAnswer[indexOfChangeItem],
        value: current.value,
      };
      setAnswers(distAnswer);
    }
  };

  const handleRemoveOneChoose = (id: number) => {
    if (id) {
      const newList = [...answers];
      setAnswers(newList.filter((item: QuestionAnswerInfo) => item.id !== id));
    } else console.error("Cannot find id");
  };

  const handleAddMoreChoose = () => {
    if (answers.length > 0) {
      const newItem = {
        id: findMaxIndexOfArray(answers) + 1,
        value: 0,
        key: findMaxIndexOfArray(answers) + 1,
        isTrue: false,
        point: 0,
        tolerance: 0,
      };
      const newList = [...answers];
      setAnswers(newList.concat([newItem]));
    } else setAnswers(initialNumericalQuestionValue);
    setDirty(true);
  };

  const resetConfig = () => {
    // setVariables([]);
    setTolerance(0);
  };

  useEffect(() => {
    resetConfig();
  }, []);

  useEffect(() => {
    setCurrentQuestionInfo({
      ...answers,
      questionName: questionName,
      tolerance: tolerance,
    });
  }, [answers, questionName, tolerance]);

  useEffect(() => {
    setQuestionName(question.question);
    if (modeQuestion === ModeQuestion.UPDATE && data.answers) {
      const feAnswer = mapAnsBEtoFE(data.answers);
      setAnswers(feAnswer as any);
      setTolerance(feAnswer[0]?.tolerance as number);
    } else {
      setAnswers([]);
    }
  }, [question, data, modeQuestion]);

  const handleChangeQuestionName = (qName: string) => {
    setQuestionName(qName);
  };

  const handleDragChange = (value: any) => {
    setAnswers(value);
    setDirty(true);
  };

  return (
    <section className="question-wrapper calculated">
      <Typography.Title level={5} className="question-title">
        {renderQuestionNameByType(question.type)}
      </Typography.Title>
      <p
        className="question-description secondary-color"
        dangerouslySetInnerHTML={{
          __html: `${renderQuestionDescriptionByType(question.type) || ""}`,
        }}
      ></p>
      <TextEditor
        value={questionName || defaultName}
        onChange={handleChangeQuestionName}
      />
      <div className="detail-calculated-config">
        <Flex align="center" gap={12} className="mt-1">
          {t("Sai số cho phép:", "Sai số cho phép:")}{" "}
          <InputNumber
            value={tolerance}
            onChange={(value) => {setTolerance(value as number); setDirty(true);}}
          />
        </Flex>
      </div>

      <div className="tree-course-construct list-answers choose-text mt-2">
        <SortableList
          items={answers}
          onChange={handleDragChange}
          renderItem={(record: any) => (
            <SortableList.Item id={record.id}>
              <SortableList.DragHandle />
              <QuestionNumericalItem
                index={record.id}
                value={record.value}
                onChange={handleChangeText}
                onDelete={handleRemoveOneChoose}
              />
            </SortableList.Item>
          )}
        />
        {answers?.length < 1 && (
          <Button
            icon={<PlusOutlined className="size-22" />}
            className="btn-add-more mt-2"
            onClick={handleAddMoreChoose}
          >
            {t("Thêm câu trả lời", "Thêm câu trả lời")}
          </Button>
        )}
      </div>
    </section>
  );
}

export default Numerical;
